var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import NumberRange from "~/components/common/number-range.vue";
import { CaseAssitCaseService } from "~/services/domain-service/case-assist-case.service.ts";
import CostMaintain from "~/components/outsource-manage/outsource-lawsuit-manage/cost-maintain.vue";
import LawsuitKind from "~/components/lawsuit-follow/lawsuit-kind.vue";
import LawsuitFollow from "~/components/lawsuit-follow/lawsuit-follow.vue";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { Getter, namespace } from "vuex-class";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var AllotModule = namespace("case-allot");
var AssistCase = /** @class */ (function (_super) {
    __extends(AssistCase, _super);
    function AssistCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseChannel = CASE_CHANNEL.law;
        _this.rowData = {};
        // 跟进是否只能查看
        _this.isView = false;
        _this.model = {
            areaIds: [],
            areaId: "",
            addressDetail: "",
            overdueDays: {
                max: "",
                min: ""
            },
            overdueAmount: {
                max: "",
                min: ""
            },
            turnSource: "",
            productCategory: "",
            creatTime: [],
            productName: "",
            lawNumber: "",
            customerCategory: "",
            overduePeriod: "",
            lawerStatus: "",
            labelName: []
        };
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            ManualDivision: false,
            isOpenLawsuitKind: false,
            isOpenLawsuitFollow: false,
            isOpenCostMaintenance: false
        };
        return _this;
    }
    Object.defineProperty(AssistCase.prototype, "lawsuit", {
        get: function () {
            return {
                kind: this.rowData.lawsuitFollowType,
                status: this.rowData.lawerStatus
            };
        },
        enumerable: false,
        configurable: true
    });
    AssistCase.prototype.mounted = function () {
        this.refreshData();
    };
    AssistCase.prototype.refreshData = function () {
        var _this = this;
        this.caseAssitCaseService
            .queryCaseAssistlist(this.model, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 手动分案
     */
    AssistCase.prototype.distributeClick = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.caseId; }));
        var caseAssistIds = this.selectionList.map(function (v) { return v.id; });
        this.updateExtData({ caseAssistIds: caseAssistIds });
        this.dialog.ManualDivision = true;
    };
    /**
     * 获取地区id
     */
    AssistCase.prototype.getAreaId = function () {
        this.model.areaId =
            this.model.areaIds.length > 0
                ? this.model.areaIds[this.model.areaIds.length - 1]
                : "";
    };
    /**
     * 点击诉讼跟进
     */
    AssistCase.prototype.lawsuitClick = function (rowData) {
        this.rowData = rowData;
        // 如果存在诉讼类型 跳过选择诉讼类型的一步
        if (!rowData.lawsuitFollowType) {
            this.dialog.isOpenLawsuitKind = true;
        }
        else {
            this.dialog.isOpenLawsuitFollow = true;
        }
    };
    /**
     * 进入查看执行页
     */
    AssistCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Lawsuit,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 范围输入框的重置
     */
    AssistCase.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.overdueDays = { max: "", min: "" };
    };
    __decorate([
        Dependencies(PageService)
    ], AssistCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AssistCase.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseAssitCaseService)
    ], AssistCase.prototype, "caseAssitCaseService", void 0);
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], AssistCase.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistCase.prototype, "updateCaseIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistCase.prototype, "updateExtData", void 0);
    __decorate([
        Getter
    ], AssistCase.prototype, "lawDepartmentDataNoRoot", void 0);
    __decorate([
        Getter
    ], AssistCase.prototype, "lawDepartmentData", void 0);
    AssistCase = __decorate([
        Auth(1504),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                CaseAllot: CaseAllot,
                NumberRange: NumberRange,
                LawsuitKind: LawsuitKind,
                CostMaintain: CostMaintain,
                LawsuitFollow: LawsuitFollow
            }
        })
    ], AssistCase);
    return AssistCase;
}(Vue));
export default AssistCase;
